import {ADD_TO_UPDS} from './actions';
import {GET_LIKE, MERGE_LIKES} from '../data/like_data';
import UpdModel from '../model/updownview';

const initalState = {
  upds: [],
  view: 0,
  voteDelta: {}
}

const bumpDelta = (voteDelta, postid, typee, adding) => {
  const id = String(postid)
  const cur = voteDelta[id] || { p: 0, d: 0 }
  const key = typee === 'd' ? 'd' : 'p'
  return {
    ...voteDelta,
    [id]: {
      ...cur,
      [key]: (Number(cur[key]) || 0) + (adding ? 1 : -1)
    }
  }
}

export default (state = initalState, actions) => {
  switch (actions.type) {
    case ADD_TO_UPDS: {
      const indexid = state.upds.findIndex(post => post.userid == actions.userid && post.postid == actions.postid && post.type === actions.typee)
      const nextDelta = actions.skipDelta
        ? state.voteDelta
        : bumpDelta(state.voteDelta, actions.postid, actions.typee, indexid < 0)
      if (indexid < 0) {
        const upd = new UpdModel(actions.typee, actions.userid, actions.postid);
        return {
          ...state,
          upds: state.upds.concat(upd),
          voteDelta: nextDelta
        }
      }
      const up = [...state.upds];
      up.splice(indexid, 1)
      return {
        ...state,
        upds: up,
        voteDelta: nextDelta
      }
    }

    case GET_LIKE:
      return {
        ...state, upds: actions.data, view: actions.view
      }

    case MERGE_LIKES: {
      const userid = String(actions.userid);
      const withoutUser = state.upds.filter(entry => String(entry.userid) !== userid);
      return {
        ...state,
        upds: withoutUser.concat(actions.data || [])
      }
    }

    default:
      return state;
  }
}